let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6uMX2")).then(() => parcelRequire('eBWFQ'));